import Alpine from 'alpinejs';
import focus from '@alpinejs/focus'

window.Alpine = Alpine;

Alpine.plugin(focus)
Alpine.start();

document.addEventListener('htmx:responseError', (event) => {
  const message = document.createElement('div');
  message.className = 'alert';
  message.setAttribute('role', 'alert');
  message.textContent = 'Something went wrong submitting this form. Please try again.';
  event.detail.target.closest('form')?.prepend(message);
});

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}